import { useEffect, useRef, useState } from "react";

/**
 * Reveal children on scroll using IntersectionObserver.
 * Usage: const [ref, visible] = useReveal();
 * <div ref={ref} className={`transition-all ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
 */
export function useReveal(options = {}) {
  const { threshold = 0.15, rootMargin = "0px 0px -80px 0px", once = true } = options;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) io.disconnect();
        } else if (!once) {
          setVisible(false);
        }
      },
      { threshold, rootMargin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold, rootMargin, once]);

  return [ref, visible];
}
